import { useEffect, useRef } from 'react';
import { useSelector } from 'react-redux';
import get from 'lodash/get';
import App from 'modules/App';
import { useAction } from 'hooks';
import SessionStorage from 'libs/SessionStorage';
import * as actions from '../../../actions';
import { SIGN_UP_FORM, IDENTITY_STATUSES } from '../../../constants';
import * as selectors from '../../../selectors';
import { getFormValues } from '../helpers';
import { useSetCountry } from './useSetCountry';
export const useSignUpEffects = (identityRequirements, identityDefaults, returnUrl, setConfirmEmailStep, setDefaultFirstStep, onSetCredentialFormValue)=>{
    const inactiveIdentity = useSelector(selectors.inactiveIdentity);
    const invitation = useSelector(selectors.invitation);
    const confirmEmailActivationType = useSelector(selectors.confirmEmailActivationType);
    const initAuth = useAction(actions.initAuth);
    const fetchIdentityProviders = useAction(actions.fetchIdentityProviders);
    const onSetFormValue = useAction(App.actions.setFormValue, SIGN_UP_FORM);
    const onSetFormValues = useAction(App.actions.setFormValues, SIGN_UP_FORM);
    const onClearForm = useAction(App.actions.clearForm, SIGN_UP_FORM);
    const setCountry = useSetCountry();
    const inactiveIdentityRef = useRef(inactiveIdentity);
    useEffect(()=>{
        const values = getFormValues(identityRequirements, identityDefaults, invitation);
        onSetFormValues(getFormValues(identityRequirements, identityDefaults, invitation));
        fetchIdentityProviders();
        const countryCode = get(values, 'countryCode');
        const appSKUCountryCode = get(values, 'appSKUCountryCode');
        if (countryCode) {
            setCountry({
                id: 'countryCode',
                value: countryCode
            }, appSKUCountryCode);
        }
        const email = get(values, 'email');
        if (email) {
            onSetCredentialFormValue({
                id: 'email',
                value: email
            });
        }
    }, []);
    useEffect(()=>{
        if (!returnUrl) {
            SessionStorage.setItem('initAuthCreate', JSON.stringify({
                identityRequirements,
                identityDefaults
            }));
            initAuth('create');
        } else {
            onSetFormValue({
                id: 'returnUrl',
                value: returnUrl
            });
        }
    }, [
        returnUrl
    ]);
    useEffect(()=>{
        if ((inactiveIdentity === null || inactiveIdentity === void 0 ? void 0 : inactiveIdentity.status) === IDENTITY_STATUSES.INACTIVE) {
            setConfirmEmailStep('ConfirmEmail');
        } else if (inactiveIdentityRef.current && !inactiveIdentity && confirmEmailActivationType === 'code') {
            setDefaultFirstStep();
        }
        inactiveIdentityRef.current = inactiveIdentity;
    }, [
        inactiveIdentity
    ]);
    useEffect(()=>()=>{
            onClearForm(SIGN_UP_FORM);
        }, []);
};
